/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

export type ClientMembershipDtoFormula = typeof ClientMembershipDtoFormula[keyof typeof ClientMembershipDtoFormula];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ClientMembershipDtoFormula = {
  BattFun: 'BattFun',
  BattFunPlus: 'BattFunPlus',
  BattFunPlusDL: 'BattFunPlusDL',
  BattForBusiness: 'BattForBusiness',
  BattFan: 'BattFan',
  BattFanPlus: 'BattFanPlus',
  BattMax: 'BattMax',
  EigenBeheer: 'EigenBeheer',
  Straal: 'Straal',
  Other: 'Other',
} as const;
